import React from 'react';
import Settings from '../../views/Settings';
import { updateSelf } from '../Header/HeaderActions'
import { getSettings, updateSettings } from './SettingsActions';
import { getCapacityTerminals } from '../Capacity/CapacityActions';
import { getTerminals } from '../Dashboard/DashboardActions';
import { connect } from 'react-redux';

class SettingsContainer extends React.Component {

  componentDidMount() {
    const { dispatchGetSettings, dispatchGetTerminals } = this.props;
    dispatchGetSettings();
    dispatchGetTerminals();
  }
  render() {
    const { settings, dispatchUpdateSelf, dispatchGetSettings, terminals, dispatchUpdateSettings } = this.props;

    return <Settings
      dispatchUpdateSelf={dispatchUpdateSelf}
      settings={settings}
      terminals={terminals}
      dispatchGetSettings={dispatchGetSettings}
      dispatchUpdateSettings={dispatchUpdateSettings}
    />;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchGetSettings: (parameters, cb) => dispatch(getSettings(parameters, cb)),
    dispatchUpdateSettings: (data, cb) => dispatch(updateSettings(data, cb)),
    getCapacityTerminals: (cb) => dispatch(getCapacityTerminals(cb)),
    dispatchGetTerminals: () => dispatch(getTerminals()),
    dispatchUpdateSelf: (parameters, cb) => dispatch(updateSelf(parameters, cb))
  };
}

function mapStateToProps({ business, settings }) {
  return { terminals: business.terminals, settings };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsContainer);


// WEBPACK FOOTER //
// ./src/containers/Settings/SettingsContainer.js